module.exports = __webpack_public_path__ + "1_0_65/img/env.bcac2232.png";